var _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblesArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 48,
    viewBox: "0 0 20 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.45294,
    r: 6.70328,
    transform: "rotate(-40.6854 10 9.45294)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.87118,
    cy: 24.0273,
    r: 5.02746,
    transform: "rotate(-40.6854 9.87118 24.0273)",
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.57762,
    cy: 35.0911,
    r: 3.63094,
    transform: "rotate(-40.6854 9.57762 35.0911)",
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.67794,
    cy: 44.1788,
    r: 2.51373,
    transform: "rotate(-40.6854 9.67794 44.1788)",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesArrow);
export default __webpack_public_path__ + "static/media/bubbles-arrow.829e1423306cfb1c570a8f40362a40b3.svg";
export { ForwardRef as ReactComponent };